import type { ComponentType, FC } from 'react';
import { useTracker } from './context';
import type { TrackerProps } from './types';

export function withTracker<P>(
    Component: ComponentType<P>,
): FC<Omit<P, keyof TrackerProps>> {
    const InnerComponent = (props: P) => {
        const tracker = useTracker();
        return <Component {...props} tracker={tracker} />;
    };

    return InnerComponent as FC<Omit<P, keyof TrackerProps>>;
}
